import template from './api-keys.html';

class ProfileApiKeysTabComponentVM
{
	constructor(params)
	{
		this.vm = params.vm;
		this.state = ko.observable('view');
		this.status_message = ko.observable('');
		this.records = ko.observableArray();
		this.selectedEditingAPIKey = ko.observable();
		this.allRoleNames = ko.observableArray();
		this.selectedRoleNames = ko.observableArray();
		this.editDescription = ko.observable();
		this.createdResult = ko.observable(null);

		// API key creation is scoped to current session user on the backend.
		// Keep management actions enabled only on own profile to avoid misleading "saved" states.
		this.can_manage_keys = ko.pureComputed(() => this.vm.is_current_user());

		this.vm.user_data.subscribe(() => {
			if (this.vm.selected_tab() == 'api_keys')
				this.update();
		});

		this.vm.selected_tab.subscribe((selectedTab) => {
			if (selectedTab == 'api_keys')
				this.update();
		});

		this.init();
	}

	async init ()
	{
		const curr_role_names = Grape.currentSession?.roles || [];
		const role_names = curr_role_names.filter((roleName) => ['all', 'guest', 'any'].indexOf(roleName) < 0);
		this.allRoleNames(role_names);
	}

	async update ()
	{
		this.state('loading');
		this.status_message('Loading keys...');

		try {
			if (!this.can_manage_keys())
			{
				this.records([]);
				this.state('view');
				return;
			}

			const data = await Grape.fetches.getJSON('/api/record', { schema: 'users', table: 'v_api_keys' });
			if (data.status == 'ERROR')
				throw new Error(data.message || data.code || 'Failed to load API keys');
			const records = [];
			for (let r of (data.records || []))
			{
				records.push({
					name: r.name,
					roles: r.attributes?.roles || [],
					description: r.attributes?.description,
					date_inserted: r.date_inserted,
					last_used: r.last_used,
					uuid: r.api_key_uuid
				});
			}
			this.records(records);
			this.state('view');
		} catch (err) {
			this.state('error');
			this.status_message(err.message);
		}
	}

	async btnSave_click ()
	{
		const obj = {
			attributes: {
				description: (this.editDescription() || '').trim(),
				roles: this.selectedRoleNames()
			}
		};

		if (!obj.attributes.description.length)
		{
			await Grape.alerts.alert({ type: 'warning', message: 'Please enter a description for the API key' });
			return;
		}

		if (!obj.attributes.roles.length)
		{
			await Grape.alerts.alert({ type: 'warning', message: 'Please select at least one access role to assign to the API key' });
			return;
		}

		let url = '/api/apikey';
		this.state('loading');
		if (this.selectedEditingAPIKey())
		{
			this.status_message('Updating API key...');
			url = `/api/apikey/${this.selectedEditingAPIKey().uuid}`;
		}
		else
			this.status_message('Creating API key...');

		try {
			const data = await Grape.fetches.postJSON(url, obj);
			if (data?.status == 'ERROR')
				throw new Error(data.message || data.code || 'Failed to save API key');
			if (!this.selectedEditingAPIKey())
				this.createdResult(data);
			this.selectedEditingAPIKey(null);
			await this.update();
		} catch (err) {
			this.state('error');
			this.status_message(err.message);
		}
	}

	async btnDelete_click (apikey)
	{
		if (!(await Grape.alerts.confirm({ type: 'warning', title: 'Delete API Key', message: 'Are you sure?' })))
			return;

		try {
			const result = await Grape.fetches.deleteJSON(`/api/apikey/${apikey.uuid}`, {});
			if (result?.status == 'ERROR')
				throw new Error(result.message || result.code || 'Failed to delete API key');
		} catch (err) {
			this.state('error');
			this.status_message(err.message);
			return;
		}

		Grape.alerts.alert({ type: 'success', title: 'Success', message: 'API key has been deleted' });
		this.update();
	}

	btnAdd_click ()
	{
		this.selectedEditingAPIKey(null);
		this.selectedRoleNames([]);
		this.editDescription('');
		this.state('new');
	}

	btnUpdate_click (data)
	{
		this.selectedEditingAPIKey(data);
		this.selectedRoleNames(data.roles || []);
		this.editDescription(data.description || '');
		this.state('edit');
	}

	btnCancel_click ()
	{
		this.selectedEditingAPIKey(null);
		this.selectedRoleNames([]);
		this.editDescription('');
		this.state('view');
	}

	copyToClipboard (data)
	{
		navigator.clipboard.writeText(data);
	}
}

export default {
	name: 'profile-api-keys-tab',
	viewModel: ProfileApiKeysTabComponentVM,
	module_type: 'ko',
	template: template
};
